import React from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { LiveNotifier } from "@/components/LiveNotifier";
import { useAuth } from "@/context/AuthContext";
import { PageLoader } from "@/components/common";

// App shell: navbar + page outlet + footer. Redirects banned users to the
// locked support screen everywhere except that screen itself.
export function Layout() {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return <PageLoader />;

  if (user?.banned && location.pathname !== "/banned") {
    return <Navigate to="/banned" replace />;
  }

  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Navbar />
      <LiveNotifier />
      <main className="flex-1">
        <Outlet />
      </main>
      <footer className="border-t border-border bg-white">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 py-6 text-sm text-muted-foreground sm:flex-row sm:px-6">
          <span className="font-display font-bold text-brand">Venda Market</span>
          <span>Zambia's marketplace · Buy &amp; sell with confidence</span>
          <span>© {new Date().getFullYear()} Venda Market</span>
        </div>
      </footer>
    </div>
  );
}

// Wrap routes that require an authenticated (non-guest) user.
export function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <PageLoader />;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  return children;
}

// Wrap routes that require admin access.
export function RequireAdmin({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <PageLoader />;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.is_admin) return <Navigate to="/" replace />;
  return children;
}
